export default {
  error_messages: {
    failed_to_fetch_orders: 'Nie udało się załadować danych. Kliknij ikonę „odśwież" lub spróbuj ponownie za 1 minutę.',
    something_went_wrong: 'Coś poszło nie tak, spróbuj ponownie.',
  },
};
